import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d3b949d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "goodsdetail",
  class: "detail rel"
}
const _hoisted_2 = { class: "viewport" }
const _hoisted_3 = { class: "goods-summary flex-bwn" }
const _hoisted_4 = {
  key: 1,
  class: "goods-picture text-ct"
}
const _hoisted_5 = { class: "text-lf mb_10" }
const _hoisted_6 = {
  key: 0,
  style: {"margin":"20px 0"},
  class: "flex flex-cen"
}
const _hoisted_7 = { class: "productDescription" }

import Category from '@/components/bussiness/Category/Category.vue'
import { useRoute, useRouter } from 'vue-router'
import { watch, computed, ref, Ref, onMounted } from 'vue'
// import StickyLiveCard from './components/StickyLiveCard.vue'
import ColumnPreview from './components/ColumnPreview.vue'
import ColumnSimilar from './components/ColumnSimilar.vue'
import ColumnSku from './components/ColumnSku.vue'
import { t } from '@/plugins/i18n'
import { useGlobal, useRequest } from '@/util/useLoading'
import { ElMessage, ElMessageBox } from 'element-plus'
import store, { getWarehouseCode, isD2C, isJA, usePlat, useSite, useSite2Station, isWhiteHiddenRMB } from '@/store'
import WaterMarkImage from '@/components/WaterMarkImage/index.vue'
import CarefullyChosen from './components/CarefullyChosen.vue'
import NationalChosen from './components/NationalChosen.vue'
import CategoryType from './components/categoryType.vue'
import { floatingRate } from '@/util/useYan'
import { Site } from '@/common/const'
import { wait } from '@/plugins/utils'
import CommonTip from '@/components/CommonTip/index.vue'
import { extProductRespDTO, getUnderLineProductPrice } from './data'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { request } from '@/config/request/interceptors'
import { ProductPropGroupRespDTO, ProductRespDTO } from '@/service/goods'
import { AdaptInfo, CategoryAdaptInfo, CustomerAdditionTemplateInfoRespDTO } from '@/service/settlement'
import FromEmail from '@/components/coupon/fromEmail.vue'
interface PI {
  liveSellPriceStartTime: string
  liveSellPriceEndTime: string
  liveSellPrice: string
}
interface MaterialInfo {
  materials?: { percentFlag: number, name: string, content: number }[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const curShop = computed(() => store.state.route.curShop)
const isLive = ref(false)
const product: Ref<extProductRespDTO> = ref({})
const hiddenRMB = computed(() => {
  return product.value?.switchAllIncludePriceJp === 1 && isWhiteHiddenRMB()
})
watch(() => curShop.value, () => {
  if (curShop.value) {
    location.reload()
  }
})

// 是否拿到SKU (最多请求10次)
const getSkuNum = ref(0)
if (route.query.directToAgent) {
  store.commit('status/d2dLoading', true)
}
// 所有 sku 的映射关系
const productCateMap = ref<Record<string, any>>({})
const isAllCalUser = computed(() => store.state.route.isAllCalUser)
console.log(isAllCalUser, 'isAllCalUser')

const fetchData = (productCode: string) => {
  return request.goods.product.detail({ productCode, needBrandInfo: 1 }).then(async (res) => {
    if (res.success) {
      if (isJA() && (res.data?.brandFlag || res.data?.choiceFixedPriceFlag === 1)) {
        location.href = `/choice/${productCode}`
        return
      }
      if (isJA() && window.screen.width < 500) {
        window.location.href = `${window.location.origin}/h5/promotion/goodsDetail?productCode=${productCode}`
        return
      }
      let data = res.data! as extProductRespDTO
      if (!data) return
      if (!isJA()) {
        data.switchAllIncludePriceJp = 0
      }

      if (data?.isOnePsale) {
        data.consignRangePrice = (data.consignPrice === data.consignPriceMax || !data.consignPriceMax) ? data.consignPrice : data.consignPrice + '-' + data.consignPriceMax
      }
      data.isfavo = data?.favoriteFlag
      data.finalProductSellPrice = data?.productSellPriceRange
      data.finalProductSellPriceJpy = data?.productSellPriceRangeJpy
      // 阶梯价
      data.productBuyMininum = data.productBuyMininum || 1
      const ld = data?.productPriceLadderList || []
      // 有阶梯价默认统一为最大的阶梯价
      data.skuList = data.skuList?.map((i: any) => {
        return {
          ...i,
          productSellPrice: ld[0]?.price || i.productSellPrice,
          originSkuPrice: i.productSellPrice
        }
      })
      const priceName =
        data.switchAllIncludePriceJp === 1 && isJA()
          ? 'allIncludePriceJp'
          : 'price'
      // 保证阶梯价格不能全部相同 1个时仍展示
      const showLladder = (ld.length >= 2 && new Set(ld.map((i: any) => i[priceName])).size > 1) || ld.length === 1
      data.showLladder = showLladder
      data.ladder = ld.map((v: any, i: number) => {
        return {
          text:
            i === ld.length - 1
              ? `≥${v.count}`
              : `${v.count}~${ld[i + 1].count! - 1}`,
          ...v
        }
      })
      if (getSkuNum.value === 0 || data.skuList?.length) {
        product.value = { ...res.data } as any
      }

      if (!data.skuList?.length && getSkuNum.value < 10) {
        getSkuNum.value++
        skuLoading.value = true
        wait(500, requestApi(prevId.value))
        return
      } else {
        getSkuNum.value = 0
      }
      taTrack({
        event: TaEvent.PRODUCT_DETAIL_PAGEVIEW,
        value: {
          product_code: productCode,
          product_title_ja: data?.productTitle
        }
      })

      const isHaveLiveGoods = (data?.skuList || []).some((item: any) => {
        return checkLiveTime(item)
      })
      const isAllCal = (data.fixedPriceFlag === 1 && isAllCalUser.value && isJA() && data.country !== 'KR') && !data.switchAllIncludePriceJp
      data.isAllCal = isAllCal
      let categoryAdaptInfoRes: CategoryAdaptInfo[] | undefined
      if (isAllCal) {
        categoryAdaptInfoRes = (await request.settlement.allInclude.categoryAdaptInfo())?.data
        const cateCodes = [...new Set(data.skuList?.map((i) => i?.productCateCode ?? ''))]
        const checkCategoryRes = (await request.settlement.allInclude.checkCategory({ productCategoryCodeList: cateCodes }))?.data
        const additionTemplates = (await request.settlement.addition.customerTemplateListCustomerAdditionTemplate({
          supportAllInclude: true,
          systemSource: isD2C() ? 1 : 2,
          templateType: 1,
          warehouseCode: getWarehouseCode(data.country === 'KR' && data.platformType === 'OL')
        })).data
        let customerTemplateInfoList: CustomerAdditionTemplateInfoRespDTO[] | undefined
        if (additionTemplates?.length) {
          customerTemplateInfoList = (await request.settlement.addition.customerTemplateInfoList({ additionTemplateIdListStr: additionTemplates?.map(i => i.additionTemplateId).join(',') })).data
        }
        const mapVal = new Map()
        checkCategoryRes?.forEach((i, idx) => {
          mapVal.set(cateCodes[idx], i.classificationCode ?? '0001')
        })
        productCateMap.value = mapVal
        // ---- 仅仅为了首页详情显示商品 tag 标记 ----start
        const categoryCode = categoryAdaptInfoRes?.find(i => i.adaptInfoList?.some(j => j.adaptType === data.season))?.categoryCode ?? mapVal.get(product.value.productCateCode)
        if (!data.season) {
          data.adaptTypeModifyFlag = true
          if (categoryCode) {
            data.season = categoryAdaptInfoRes?.find(i => i?.categoryCode === categoryCode)?.adaptInfoList?.[0]?.adaptType
          }
        }
        data.categoryCode = categoryCode
        data.seasonTag = categoryAdaptInfoRes?.reduce((pre, cur) => {
          return [...pre, ...(cur.adaptInfoList ?? [])]
        }, [] as AdaptInfo[]).find(i => i.adaptType === data.season)?.adaptTypeNameJp
        // ---- 仅仅为了首页详情显示商品 tag 标记 ----end

        // 一价全包商品需要增加分类及适配类型数据
        data.skuList = data.skuList?.map(item => {
          if (isAllCal) {
            const categoryCode = categoryAdaptInfoRes?.find(i => i.adaptInfoList?.some(j => j.adaptType === item.season))?.categoryCode ?? productCateMap.value.get(item.productCateCode) ?? '0001'
            item.categoryCode = categoryCode
            item.adaptType = item.season
            if (categoryCode) {
              const itemInfoRespDTOList = customerTemplateInfoList?.find(i => i.categoryCode === item.categoryCode)?.itemInfoRespDTOList
              item.additionIdList = itemInfoRespDTOList?.map(i => i.additionId!)
              item.additionList = itemInfoRespDTOList
            }
            if (!item.season) {
              item.adaptTypeModifyFlag = true
              if (categoryCode) {
                item.adaptType = categoryAdaptInfoRes?.find(i => i?.categoryCode === categoryCode)?.adaptInfoList?.[0]?.adaptType
              }
            }
          }
          return item
        })
      }
      isLive.value = !!route.query.activityId && isHaveLiveGoods
      // 如果有直播商品 或者线下商品重新计算价格
      if (isLive.value) {
        let minPrice: any = 0
        let maxPrice: any = 0
        let minPriceJPY: any = 0
        let maxPriceJPY: any = 0
        // 过滤非直播价的商品
        data.skuList = (data?.skuList || []).filter((item: any) => {
          return checkLiveTime(item)
        })
        data.skuList.forEach((item) => {
          item.productSellPrice = item.liveSellPrice
          minPrice = !minPrice ? item.liveSellPrice : Math.min(minPrice, item.liveSellPrice!)
          maxPrice = !maxPrice ? item.liveSellPrice : Math.max(maxPrice, item.liveSellPrice!)
          minPriceJPY = Math.round(minPrice * floatingRate.value)
          maxPriceJPY = Math.round(maxPrice * floatingRate.value)
          item.isLive = true
        })
        // 直播商品重新计算价格区间
        if (minPrice !== maxPrice) {
          data.finalProductSellPrice = `${minPrice}-${maxPrice}`
          data.finalProductSellPriceJpy = `${minPriceJPY}-${maxPriceJPY}`
        } else {
          data.finalProductSellPrice = String(minPrice)
          data.finalProductSellPriceJpy = minPriceJPY
        }
        data.productSellPrice = minPrice
      }
      data = getUnderLineProductPrice(data)

      data.productPropGroupList = filterNoSkuProps(isJA() && data?.productPropGroupJaList?.length && judgeJaProps(data) ? data.productPropGroupJaList : data.productPropGroupList, (res.data as any).skuList)
      const allUrlEmpty = data.productPropGroupList?.every((i) => i?.props?.every((j) => !j.url))
      if (allUrlEmpty && data.productPropGroupList?.[0]?.props?.length) {
        data.productPropGroupList[0].props.forEach((i) => { i.url = data.productMainImg })
      }
      product.value = { ...data }
      sessionStorage.setItem(`good_${productCode}`, JSON.stringify(data))
    } else {
      if (res.code === '410000003') {
        ElMessageBox.confirm(t('该商品是私域商品，您无法下单'), t('提示'), {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning'
        })
          .then(() => {
            location.href = '/'
          })
          .catch(() => {
            location.href = '/'
          })
        return
      }
      if (res.code !== '29040001') {
        ElMessage.error(t('请求失败'))
      }
      location.href = '/'
    }
  }).finally(() =>
    setTimeout(() => {
      store.commit('status/d2dLoading', false)
    }, 1000))
}
/** 对比日本spu和中文spu是否相同 */
const judgeJaProps = (data: any) => {
  // data.productPropGroupJaList.
  return (data.productPropGroupList.length === data.productPropGroupJaList.length) && data.productPropGroupList.every((i: { props: string | any[] }, index: string | number) => {
    const ja = data.productPropGroupJaList[index]
    return i.props.length === ja.props.length
  })
}

// 是否是韩国仓商品
const isMultiGoods = computed(() => {
  return product.value.country === 'KR' && product.value.platformType === 'OL'
})
// 未获取到数据一直刷数据
const [skuLoading, requestApi] = useRequest(fetchData)

const api = useGlobal(fetchData)

const imgList = computed(() => {
  return product.value?.productDescImgs || []
})
const prevId = ref()

watch(
  route,
  (v) => {
    const { id } = v.params
    if (id && prevId.value !== id) {
      prevId.value = id
      api(id.toString())
    }
  },
  { immediate: true }
)
const checkLiveTime = (item: PI) => {
  const start = new Date(item.liveSellPriceStartTime).getTime()
  const end = new Date(item.liveSellPriceEndTime).getTime()
  const now = new Date().getTime()
  if (item.liveSellPrice && item.liveSellPriceEndTime && item.liveSellPriceStartTime) {
    if (now > start && now < end) {
      return true
    }
  }
  return false
}

/** 利用sku的key去除 不需要的规格属性productPropGroupList */
const filterNoSkuProps = (propList?: ProductPropGroupRespDTO[], sku?: any[]) => {
  if (sku?.length === 0 || propList?.length === 0) return []
  let keys: string[] = []
  sku?.forEach((item: any) => {
    keys = [...keys, ...item.productProperties.split(';')]
  })

  return propList?.map((item: any) => {
    return {
      ...item,
      props: item.props.filter((i: any) => keys.includes(i.propKey))
    }
  })
}

// 根据站点获取商品描述
const getProductDescription = (stationCode: Site) => {
  if (stationCode === Site.JA) {
    return product.value?.productDescriptionJa
  } else if (stationCode === Site.KO) {
    return product.value?.productDescriptionKr
  } else {
    return product.value?.productDescriptionEn
  }
}

const productPropsJa = computed(() => {
  const info = product.value?.productPropsJa
  try {
    if (info) {
      return JSON.parse(info)
    } else {
      return []
    }
  } catch (error) {
    return []
  }
})

const capitalizeFirstLetter = (str: string) => {
  // 将字符串的第一个字母转换为大写，然后与剩余部分拼接起来
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const materialInfo = computed(() => {
  const site = capitalizeFirstLetter(useSite())
  const key = `materialInfo${site}Json`
  console.log(product.value, key)
  try {
    const t: any = product.value ?? {}
    const value: any[] = JSON.parse(t[key])
    console.log({ materialInfo: value })
    const mat = value.map(v => v.materials).flat().map(v => {
      return {
        name: v.name,
        value: v.content + '%'
      }
    })
    return mat
  } catch (err) {
    return []
  }
})

const getMaterialInfoJSON = computed<MaterialInfo[]>(() => {
  try {
    const list = JSON.stringify(getMaterialInfo(useSite2Station()) ?? '[]') as any
    return list.map((i: any) => {
      return {
        // name:i.materials
      }
    })
  } catch (error) {
    return []
  }
}
)

const getMaterialInfo = (stationCode: Site) => {
  if (stationCode === Site.JA) {
    return product.value?.materialInfoJaJson
  } else if (stationCode === Site.KO) {
    return product.value?.materialInfoKrJson
  } else {
    return product.value?.materialInfoEnJson
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FromEmail),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Category),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CommonTip, { name: "stopPurchase" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ColumnPreview, {
            product: product.value,
            productDetailUrl: product.value.productDetailUrl,
            isMultiGoods: _unref(isMultiGoods)
          }, null, 8, ["product", "productDetailUrl", "isMultiGoods"]),
          _createVNode(ColumnSku, {
            skuLoading: _unref(skuLoading),
            product: product.value,
            isLive: isLive.value,
            isMultiGoods: _unref(isMultiGoods),
            hiddenRMB: _unref(hiddenRMB)
          }, null, 8, ["skuLoading", "product", "isLive", "isMultiGoods", "hiddenRMB"]),
          (!['OL', 'YS', 'XZ'].includes(product.value.platformType ?? ''))
            ? (_openBlock(), _createBlock(ColumnSimilar, {
                key: 0,
                product: product.value
              }, null, 8, ["product"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(isJA)() && (product.value.productPropsJa))
          ? (_openBlock(), _createBlock(CategoryType, {
              key: 0,
              list: _unref(productPropsJa)
            }, null, 8, ["list"]))
          : _createCommentVNode("", true),
        _createVNode(CategoryType, {
          title: _unref(t)('商品材质'),
          list: _unref(materialInfo)
        }, null, 8, ["title", "list"]),
        (_unref(imgList).length || getProductDescription(_unref(useSite2Station)())?.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('商品详情')), 1),
              (getProductDescription(_unref(useSite2Station)())?.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(getProductDescription(_unref(useSite2Station)())), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgList), (v) => {
                return (_openBlock(), _createBlock(WaterMarkImage, {
                  isElImage: "",
                  waterMark: (product.value.productTag === 1 || product.value.countryProductTag === 1) && _unref(isJA)(),
                  key: v,
                  "data-goods": "",
                  src: v
                }, null, 8, ["waterMark", "src"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})